import { SET_FOLDERS, ADD_FOLDER, UPDATE_FOLDER, REMOVE_FOLDER } from './types';
import axios from 'axios';

export const getAllFolders = () => async (dispatch) => {
	try {
		const res = await axios.get(`/api/folders`);

		if (res.data.folders && !res.data.error) {
			dispatch({
				type: SET_FOLDERS,
				payload: res.data,
			});
			return;
		}

		dispatch({ type: SET_FOLDERS, payload: [] });
	} catch (err) {
		console.log('Error fetching folders', err.message);
		dispatch({ type: SET_FOLDERS, payload: [] });
	}
};

export const addFolder =
	({ folderTitle }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/folders/create-new-folder', {
				folderTitle,
			});

			if (res.data.folder && !res.data.error) {
				dispatch({
					type: ADD_FOLDER,
					payload: res.data.folder,
				});
			}
		} catch (err) {
			// need to add a notification here
			console.log('Error adding folder', err.message);
		}
	};

export const renameFolder =
	({ newFolderTitle, _folder }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/folders/rename-folder', {
				newFolderTitle,
				_folder,
			});

			if (res.data.folder && !res.data.error) {
				dispatch({
					type: UPDATE_FOLDER,
					payload: res.data.folder,
				});
			}
		} catch (error) {
			console.log('Error updating folder', error.message);
		}
	};

export const removeFolder =
	({ _folder }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/folders/remove-folder', {
				_folder,
			});

			if (res.data._folder && !res.data.error) {
				dispatch({
					type: REMOVE_FOLDER,
					payload: res.data._folder,
				});
			}
		} catch (error) {
			console.log('Error removing folder', error.message);
		}
	};

export const addFolderToConversation =
	({ _folder, _conversation, _business }) =>
	async () => {
		try {
			const res = await axios.post(
				'/api/folders/add-folder-to-customer-conversation',
				{
					_folder,
					_conversation,
					_business,
				}
			);

			if (res.data.error) {
				return { error: true, message: res.data.message };
			}

			return { error: false, message: 'Folder added to conversation' };
		} catch (error) {
			console.log('Error adding folder to conversation', error.message);
		}
	};

export const removeFolderFromConversation =
	({ _conversation, _business }) =>
	async () => {
		try {
			const res = await axios.post(
				'/api/folders/remove-folder-from-customer-conversation',
				{
					_conversation,
					_business,
				}
			);

			if (res.data.error) {
				return { error: true, message: res.data.message };
			}

			return {
				error: false,
				message: 'Folder removed from conversation',
			};
		} catch (error) {
			console.log(
				'Error removing folder from conversation',
				error.message
			);
		}
	};
